import React from "react";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./TimePicker.css";

const { t } = new Translate("DateTime");

const TimePicker = ({ hasDate, onChange, time }) => {
  const addTime = (
    <div className={styles.placeholder}>
      <div className={styles.title}>{t("add_time")}</div>
      <div className={styles.subtitle}>{t("add_date")}</div>
    </div>
  );
  const inputs = time ? (
    <div>
      <div className={styles.header}>{t("time")}</div>
      <div className={styles.input}>
        <input onChange={(evt) => onChange(evt.target.value)} type="time" value={time} />
      </div>
    </div>
  ) : (
    <button className={styles.addTime} onClick={() => onChange("00:00")}>
      {t("add_time")}
    </button>
  );

  return <div className={styles.root}>{hasDate ? inputs : addTime}</div>;
};

TimePicker.propTypes = {
  hasDate: PropTypes.bool,
  time: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default TimePicker;
